import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

import { platformBrowser } from '@angular/platform-browser';
import { environment } from '@env/environment';
import { AppModule } from 'app.module';
import { EnvironmentNamesEnum } from 'shared/constants/general-constants';

if (environment.production) {
    enableProdMode();
}

if (environment.name !== EnvironmentNamesEnum.dev && environment.name !== EnvironmentNamesEnum.featureDev && environment.dev !== true) {
    let zohoScript = document.createElement('script');
    zohoScript.type = 'text/javascript';
    zohoScript.innerHTML = `
        var $zoho = $zoho || {};
        $zoho.salesiq = $zoho.salesiq || {
            widgetcode: "${
                environment.production
                    ? 'siq8f0ffa28cd9afc5fee821b62ddf8b3a4512f05a216726280bf6b152fb2abc54238ab2bd56b9c6c9b6edfa062372fa65e'
                    : 'siqc8f8c67d3b67ec602f0fbac22730751b101394a24caf12880ee0fe0f7644750f'
            }",
            values: {},
            ready: function () {}
        };


        var chatBotScript = document.createElement("script");
        chatBotScript.type = "text/javascript";
        chatBotScript.id = "zsiqscript";
        chatBotScript.defer = true;
        chatBotScript.src = "https://salesiq.zoho.com/widget";

        document.head.appendChild(chatBotScript);
    `;
    document.head.appendChild(zohoScript);
}

platformBrowser()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch((err) => {
        if (!environment.production) {
            console.error(err);
        }
    });
